import * as React  from "react";
import { useState, useEffect } from "react";
import axios from 'axios';
import AutoSendSetting from './index/auto_send_setting';

interface MessageTemplate {
  id: string;
  message: string;
  message_kbn: number;
  message_name: string;
}

const MESSAGE_KBN = { PAYMENT_COMPLETION: 4, VIDEO_START: 5, PAYMENT_FAILED: 7, PAYMENT_IN_PROCESS: 8 }

const Index = (props) => {
  const [messageTemplates, setMessageTemplate] = useState([]);
  const [paymentCompletionTemplate, setPaymentCompletionTemplate] = useState(null);
  const [videoStartTemplate, setVideoStartTemplate] = useState(null);
  const [paymentFailedTemplate, setPaymentFailedTemplate] = useState(null);
  const [paymentInProcessTemplate, setPaymentInProcessTemplate] = useState(null);

  useEffect(() => {
    async function fetchMessageTemplates() {
      const messageTemplates = await axios.get<MessageTemplate[]>(
        '/api/internal/messages/index',
      );
      setMessageTemplate(messageTemplates.data);
      const paymentCompletionTemplate = messageTemplates.data.find(template => template['message_kbn'] === MESSAGE_KBN.PAYMENT_COMPLETION);
      const videoStartTemplate = messageTemplates.data.find(template => template['message_kbn'] === MESSAGE_KBN.VIDEO_START);
      const paymentFailedTemplate = messageTemplates.data.find(template => template['message_kbn'] === MESSAGE_KBN.PAYMENT_FAILED);
      const paymentInProcessTemplate = messageTemplates.data.find(template => template['message_kbn'] === MESSAGE_KBN.PAYMENT_IN_PROCESS);
      setPaymentCompletionTemplate(paymentCompletionTemplate);
      setVideoStartTemplate(videoStartTemplate);
      setPaymentFailedTemplate(paymentFailedTemplate);
      setPaymentInProcessTemplate(paymentInProcessTemplate);
    }
    fetchMessageTemplates();
  }, []);

  return(
    <React.Fragment>
      <h3>メッセージテンプレート一覧</h3>
      <br />
      <div className="table-responsive message-table-content">
        <table id="notice_table" className="table table-bordered">
          <thead>
            <tr className="success">
              <th scope="col" className="text-center col-lg-2">メッセージ</th>
              <th scope="col" className="text-center col-lg-2">編集</th>
            </tr>
          </thead>
          <tbody>
            {messageTemplates.map((messageTemplate, i) => (
              <tr key={i}>
                <td className="va_middle">{messageTemplate.message_name}</td>
                <td className="text-center under"><a href={"/messages/edit?id=" + messageTemplate.id}>編集</a></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <AutoSendSetting
        videoStartRemindTimeOptions={props.videoStartRemindTimeOptions}
        paymentCompletionTemplate={paymentCompletionTemplate}
        videoStartTemplate={videoStartTemplate}
        setPaymentCompletionTemplate={setPaymentCompletionTemplate}
        setVideoStartTemplate={setVideoStartTemplate}
        paymentFailedTemplate={paymentFailedTemplate}
        setPaymentFailedTemplate={setPaymentFailedTemplate}
        paymentInProcessTemplate={paymentInProcessTemplate}
        setPaymentInProcessTemplate={setPaymentInProcessTemplate}
      />
    </React.Fragment>
  );
}

export default Index
